interface IsAuDomesticAirportRouteParams {
  airports: Array<App.Airport>
  departureAirportCode?: string
  destinationAirportCode?: string
}

export default function isAuDomesticAirportRoute({
  airports,
  departureAirportCode,
  destinationAirportCode,
}: IsAuDomesticAirportRouteParams): boolean {
  const departureAirport = airports.find(({ code }) => code === departureAirportCode)
  const destinationAirport = airports.find(({ code }) => code === destinationAirportCode)

  return departureAirport?.countryCode?.toUpperCase() === 'AU' &&
    destinationAirport?.countryCode?.toUpperCase() === 'AU'
}
